import { memo } from 'react';
import { LockedLabelProps } from './LockedLabel.types';
import { Box, Icon, Text } from '@bonanza-social/moonlight';

function LockedLabel({ label }: LockedLabelProps) {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="space-100"
      alignSelf="center"
      paddingTop="space-050"
    >
      <Icon name="lockFilled" color="iconSecondary" width="space-300" height="space-300" />
      <Text variant="caption" color="darkSurfacePrimary">
        {label}
      </Text>
    </Box>
  );
}

export default memo(LockedLabel);
